<section class="chat-widget" aria-label="Frantinco AI">
  <div class="chat-panel" *ngIf="isOpen">
    <header class="chat-header">
      <div>
        <h2>Frantinco AI</h2>
      </div>

      <div class="header-actions">
        <button class="icon-button" type="button" (click)="resetChat()" aria-label="Chat baru" title="Chat baru">
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <path d="M4 5v6h6M20 19v-6h-6" />
            <path d="M5.5 9A7 7 0 0 1 17 5.5L20 8M18.5 15A7 7 0 0 1 7 18.5L4 16" />
          </svg>
        </button>
        <button class="icon-button" type="button" (click)="closeChat()" aria-label="Tutup chat" title="Tutup">
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <path d="M18 6 6 18M6 6l12 12" />
          </svg>
        </button>
      </div>
    </header> 

    <div class="chat-messages" #messagesContainer>
      <div class="empty-state" *ngIf="chatHistory.length === 0">
        <strong>Halo, ada yang bisa dibantu?</strong>
        <span>Tanya produk frantinco, aplikasi, atau spesifikasinya.</span>
      </div>

      <div
        class="message-row"
        *ngFor="let msg of chatHistory"
        [class.user-row]="msg.role === 'User'"
        [class.support-row]="msg.role !== 'User'"
      >
        <div
          class="message-bubble"
          [class.user-bubble]="msg.role === 'User'"
          [class.support-bubble]="msg.role !== 'User'"
          [class.has-products]="msg.products?.length"
        >
          <span class="message-role">{{ msg.role === 'User' ? 'Anda' : 'Technical Support' }}</span>
          <div class="message-text">
            <p>{{ msg.content }}</p>
          </div>

          <div class="product-preview-list" *ngIf="msg.products?.length">
            <div
              class="product-preview-card"
              *ngFor="let product of msg.products"
              [class.disabled-preview]="!product.imageUrl && !product.thumbnailUrl"
            >
              <a
                class="product-thumbnail"
                [class.no-image]="!product.thumbnailUrl"
                [attr.href]="product.imageUrl || product.thumbnailUrl || null"
                target="_blank"
                rel="noopener noreferrer"
                [attr.aria-label]="'Buka gambar ' + product.name"
              >
                <img *ngIf="product.thumbnailUrl" [src]="product.thumbnailUrl" [alt]="product.name" loading="lazy" />
                <span *ngIf="!product.thumbnailUrl">{{ product.displayCode || product.code }}</span>
              </a>
              <div class="product-preview-copy">
                <strong>{{ product.displayCode || product.code }}</strong>
                <span>{{ product.name }}</span>
                <small>{{ product.series }}<ng-container *ngIf="product.dimension"> - {{ product.dimension }}</ng-container></small>
                <div class="asset-links" *ngIf="product.hiresUrl || product.view360Url">
                  <a
                    class="asset-link"
                    *ngIf="product.hiresUrl"
                    [href]="product.hiresUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ product.category === 'E-Katalog' ? 'GDRIVE' : 'HIRES' }}
                  </a>
                  <a
                    class="asset-link"
                    *ngIf="product.view360Url"
                    [href]="product.view360Url"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    360
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="sales-contact-list" *ngIf="msg.salesContacts?.length">
            <article class="sales-contact-card" *ngFor="let contact of msg.salesContacts">
              <div class="sales-contact-copy">
                <strong>{{ contact.fullName }}</strong>
                <div class="sales-contact-meta">
                  <span *ngIf="contact.nickname">{{ contact.nickname }}</span>
                  <small>{{ contact.area }}</small>
                </div>
              </div>

              <div class="sales-contact-actions">
                <a
                  class="whatsapp-link"
                  *ngIf="contact.whatsappUrl"
                  [href]="contact.whatsappUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  [attr.aria-label]="'Chat WhatsApp ' + contact.fullName"
                >
                  <svg aria-hidden="true" viewBox="0 0 24 24">
                    <path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8Z" />
                    <path d="M9.2 8.7c.2-.4.4-.4.7-.4h.5c.2 0 .4.1.5.4l.5 1.2c.1.3.1.5-.1.7l-.3.4c.5.8 1.1 1.4 2 1.9l.4-.4c.2-.2.4-.2.7-.1l1.2.6c.3.1.4.3.4.6v.5c0 .3-.1.5-.4.7-.4.2-.9.3-1.4.2-2.6-.4-4.8-2.5-5.2-5.1-.1-.5 0-1 .2-1.4Z" />
                  </svg>
                  {{ contact.phone }}
                </a>
                <a
                  class="email-link"
                  *ngIf="contact.email"
                  [href]="'mailto:' + contact.email"
                  [attr.title]="contact.email"
                  [attr.aria-label]="'Email ' + contact.fullName"
                >
                  <svg aria-hidden="true" viewBox="0 0 24 24">
                    <path d="M4 6h16v12H4z" />
                    <path d="m4 7 8 6 8-6" />
                  </svg>
                  Email
                </a>
              </div>
            </article>
          </div>
        </div>
      </div>

      <div class="message-row support-row" *ngIf="isLoading">
        <div class="message-bubble support-bubble typing-bubble">
          <span class="message-role">Technical Support</span>
          <div class="typing-indicator" aria-label="Technical Support sedang mengetik">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>

    <form class="chat-composer" (ngSubmit)="send()">
      <textarea
        #messageTextarea
        [(ngModel)]="userInput"
        name="message"
        rows="1"
        (input)="resizeComposer($event)"
        (keydown)="onMessageKeydown($event)"
        placeholder="Tulis pertanyaan..."
      ></textarea>
      <button
        class="send-button"
        type="submit"
        [class.is-loading]="isLoading"
        [disabled]="isLoading || !userInput.trim()"
        [attr.aria-label]="isLoading ? 'Menunggu balasan' : 'Kirim pesan'"
      >
        <span class="send-loader" *ngIf="isLoading" aria-hidden="true"></span>
        <svg aria-hidden="true" viewBox="0 0 24 24" *ngIf="!isLoading">
          <path d="m22 2-7 20-4-9-9-4Z" />
          <path d="M22 2 11 13" />
        </svg>
      </button>
    </form>
  </div>

  <button
    class="floating-chat-button"
    type="button"
    [class.panel-open]="isOpen"
    (click)="toggleChat()"
    aria-label="Buka chat Technical Support"
  >
    <svg aria-hidden="true" viewBox="0 0 24 24" *ngIf="!isOpen">
      <path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8Z" />
    </svg>
    <svg aria-hidden="true" viewBox="0 0 24 24" *ngIf="isOpen">
      <path d="M18 6 6 18M6 6l12 12" />
    </svg>
  </button>
</section>
